import apiClient from '../apiClient';
import { DELETE_ADDITIONAL_INFO_PACKAGE_URL } from '../apiUrl';

const deleteAdditionalInfoApi = id => {
  return apiClient.delete(DELETE_ADDITIONAL_INFO_PACKAGE_URL(id));
};

export default deleteAdditionalInfoApi;
